(function (angular) {
    'use strict';

    angular.module('chat2')

        .controller('transferChatModal', ["$scope", "$stateParams", "$uibModalInstance", "teamSettingsService", "chatPresenceService", 'NgTableParams', '$filter', 'jwtService', 'usersService',
            function ($scope, $stateParams, $uibModalInstance, teamSettingsService, chatPresenceService, NgTableParams, $filter, jwtService, usersService) {

                /**
                 * 
                 * @param {*} members 
                 */
                function getTeamPresence(members) {

                    var profileIds = [];

                    angular.forEach(members, function (member) {
                        member.profileId = "PLATFORMUSER\\" + member.username;
                        profileIds.push(member.profileId);
                    }, this);

                    var _users = [];

                    return usersService.getUsers(jwtService.payload.accountId)
                        .then(function (users) {
                            _users = users;
                            return chatPresenceService.getPresences($stateParams.pickedApiSpaceId, profileIds);
                        })
                        .then(function (result) {

                            angular.forEach(result, function (m) {

                                var found = members.find(function (obj) {
                                    return obj.profileId === m.profileId;
                                });

                                if (found) {
                                    found.status = m.status;
                                }

                                var foundUser = _users.find(function (obj) {
                                    return ("PLATFORMUSER\\" + obj.userName) === found.profileId;
                                });

                                if (foundUser) {
                                    found.avatarUrl = foundUser.avatarUrl;
                                }

                            }, this);

                            return members;
                        });
                }

                var _config;

                teamSettingsService.getChatConfig($stateParams.pickedApiSpaceId)
                    .then(function (config) {
                        _config = config;
                        return teamSettingsService.getTeams($stateParams.pickedApiSpaceId);
                    })
                    .then(function (result) {
                        if (result.length) {
                            $scope.teams = result;
                            $scope.setCurrentTeam($scope.teams[0]);
                        }
                    });

                $scope.getName = function (team) {
                    if (team && $scope.teams) {
                        return $scope.teams.find(function (t) { return t.id === team }).name;
                    } else {
                        return "";
                    }

                }

                $scope.setCurrentTeam = function (team) {

                    var ct = _config.teams.find(function (t) { return t.teamId === team.id });

                    $scope.currentTeamAvatar = ct && ct.settings && ct.settings.avatarUrl || "./assets/img/icons/syg.png";
                    $scope.currentTeam = team.id;
                    $scope.users = team.members;

                    if (team.members && team.members.length > 0) {
                        getTeamPresence(team.members)
                            .then(function (members) {

                                $scope.tableParams = new NgTableParams(
                                    {
                                        page: 1,
                                        count: 10,
                                        // initial sort order
                                        sorting: { name: "desc" }
                                    },
                                    {
                                        // counts: [], // hides page sizes
                                        getData: function ($q, params) {
                                            var orderedData = params.sorting() ?
                                                $filter('orderBy')(members, params.orderBy()) : members;
                                            params.total(members.length);

                                            $q.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
                                        }
                                    });
                            });
                    }

                }

                $scope.ok = function () {
                    $uibModalInstance.close($scope.transferInfo);
                };

                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                $scope.transferToAgent = function (member) {

                    $uibModalInstance.close({
                        profileId: member.username,
                        teamId: $scope.currentTeam
                    });

                }

                $scope.transferToTeam = function () {

                    $uibModalInstance.close({
                        profileId: undefined,
                        teamId: $scope.currentTeam
                    });
                }

            }]);

})(window.angular);
